import moment from "moment";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import ImageLoader from "react-load-image";
import { connect } from "react-redux";
import loaderImage from "../../assets/img/Ring-Preloader.gif";
import { getDashboardTasksWidgetAction } from "./../../actions/DashboardActions";
import placeholderImage from "./../../assets/img/property-placeholder.jpg";
import UrlConstants from "./../../config/UrlConstants";
import { getTimeFromMins } from "./../Common/Common";

function Preloader(props) {
  return <img src={loaderImage} />;
}

class DashboardTasksWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMode: "week",
      scheduledTasks: 0,
      totalTasks: 0,
      overdueTasks: 0,
    };
  }

  componentWillMount() {
    //call api for get task widget data
    this.props
      .getDashboardTasksWidgetAction()
      .then((res) => {
        this.setState({
          scheduledTasks: res.transactionStatus
            ? res.transactionStatus["NOT DUE"] || 0
            : 0,
          totalTasks: res.totalTask || 0,
          overdueTasks: res.transactionStatus
            ? res.transactionStatus.OVERDUE || 0
            : 0,
        });
      })
      .catch((err) => {
        /*if api fails then no need to update state*/
      });
  }

  goToTaskDetails(id, transactionId) {
    this.props.history.push({
      pathname: "/artwork/detail/" + transactionId,
      taskId: id,
    });
  }

  goToAllTask(taskType) {
    localStorage.setItem("taskType", taskType);
    this.props.history.push({ pathname: "/AllTaskList", taskType: taskType });
  }

  /**
   * @desc check task status as over due by local time
   * @param {*} t
   */
  checkOverDue(t) {
    t.eventEndDate = new Date(
      moment(t.eventEndDate).format("MM/DD/YYYY ") + getTimeFromMins(t.time)
    );
    var color = "blue";
    if (t.status == "SCHEDULED") {
      color = "blue";
      if (moment(t.eventEndDate) < moment()) {
        color = "orange";
      }
    } else if (t.status == "COMPLETED") {
      color = "green";
    }

    return color;
  }

  render() {
    var tasks = this.props.upcomingTasksData.transactionsEvent || [];

    if (this.state.viewMode == "day") {
      tasks = tasks.filter((e) => {
        return moment().isSame(e.eventEndDate, "day");
      });
    }
    return (
      <React.Fragment>
        <div className="dash-col dash-col-big">
          <div className="dash-col-inner">
            <div className="dash-col-head with-border">
              <Row className="align-items-center">
                <Col>
                  <h4 className="color-blue-3 font-16 font-600 mb-0">
                    Upcoming Tasks
                  </h4>
                </Col>
                <Col align="right" className="col-auto">
                  <div className="switch-btns">
                    <Button
                      variant="primary"
                      className={this.state.viewMode == "day" && "active"}
                      onClick={() => {
                        this.setState({ viewMode: "day" });
                      }}
                    >
                      Day
                    </Button>
                    <Button
                      variant="primary"
                      className={this.state.viewMode == "week" && "active"}
                      onClick={() => {
                        this.setState({ viewMode: "week" });
                      }}
                    >
                      Week
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
            {tasks.length == 0 ? (
              <div className="dash-no-records">No Records Found</div>
            ) : (
              <div className="upc-task">
                <div className="upc-task-row upc-task-row-head">
                  <div className="upc-task-col">Task</div>
                  <div className="upc-task-col">Transaction</div>
                </div>

                <div className="upc-task-row-body">
                  {tasks.map((task, i) => {
                    return (
                      <div
                        key={"ts" + i}
                        className="upc-task-row task-row"
                        onClick={() => {
                          this.goToTaskDetails(
                            task._id,
                            task.transactionData._id
                          );
                        }}
                      >
                        <div className="upc-task-col">
                          <Row className="align-items-center">
                            <Col className="col-auto pr-0">
                              <span
                                className={
                                  "task-status task-status-" +
                                  this.checkOverDue(task)
                                }
                              />
                            </Col>
                            <Col>
                              <div className="task-name">{task.title}</div>
                              <div className="task-date">
                                <em>
                                  Due date:{" "}
                                  {moment(task.eventEndDate).format(
                                    "MM/DD/YYYY hh:mm a"
                                  )}
                                </em>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        {task.transactionData && (
                          <div className="upc-task-col">
                            <div
                              className="trans-combo"
                              onClick={() => {
                                this.props.history.push(
                                  "/artwork/detail/" + task.transactionData._id
                                );
                              }}
                            >
                              <div className="trans-img">
                                {task.transactionData.property.image == null ||
                                task.transactionData.property.image.length <=
                                  0 ||
                                task.transactionData.property.image[0] == "" ? (
                                  <img src={placeholderImage} />
                                ) : (
                                  <ImageLoader
                                    src={
                                      UrlConstants.AdminCreateTransactionUrl +
                                      "/upload?id=" +
                                      task.transactionData.ownerId +
                                      "&img=" +
                                      task.transactionData.property.image[0]
                                    }
                                  >
                                    <img />
                                    <img src={placeholderImage} />
                                    <Preloader />
                                  </ImageLoader>
                                )}
                              </div>
                              <div className="trans-info">
                                <h5>
                                  {task.transactionData.property.street +
                                    (task.transactionData.property.street1 != ""
                                      ? ", " +
                                        task.transactionData.property.street1 +
                                        ""
                                      : "")}
                                </h5>
                                <p>
                                  {task.transactionData.property.city +
                                    ", " +
                                    (task.transactionData.property.state
                                      ? task.transactionData.property.state +
                                        " "
                                      : "") +
                                    task.transactionData.property.zipcode}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="dash-col task-count">
          <div className="task-count-inner">
            <div
              className="orange"
              onClick={() => {
                this.goToAllTask("OVERDUE");
              }}
            >
              <h4>{this.state.overdueTasks}</h4>
              <p>Overdue Task(s)</p>
            </div>
            <div
              className="blue"
              onClick={() => {
                this.goToAllTask("NOT DUE");
              }}
            >
              <h4>{this.state.scheduledTasks}</h4>
              <p>Scheduled Task(s)</p>
            </div>
            <div
              className="d-blue"
              onClick={() => {
                this.goToAllTask("SCHEDULED");
              }}
            >
              <h4>{this.state.totalTasks}</h4>
              <p>Total Open Task(s)</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    upcomingTasksData: state.reducer.upcomingTasksData || {},
  };
};

export default connect(
  mapStateToProps,
  { getDashboardTasksWidgetAction }
)(DashboardTasksWidget);
